import React, { useRef, useEffect } from 'react';

import './StrapiDescription.scss';

interface IStrapiDescriptionProps {
  description: string;
  hidden?: boolean;
  htmlRegexPattern?: RegExp;
  className?: string;
}

const StrapiDescription = ({
  description,
  hidden = false,
  htmlRegexPattern,
  className = '',
}: IStrapiDescriptionProps) => {
  const descriptionRef = useRef<HTMLParagraphElement | null>(null);
  // hides focus for elements not in window
  useEffect(() => {
    if (descriptionRef.current) {
      const focusable: HTMLElement[] = Array.from(
        descriptionRef?.current.querySelectorAll(
          'button:not([tabindex="-1"]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      );
      focusable.forEach((element) =>
        element.setAttribute('tabIndex', hidden ? '-1' : '0')
      );
    }
  }, [descriptionRef, hidden]);

  return (
    <div
      className={`description strapi-description ${className}`}
      dangerouslySetInnerHTML={{
        __html: htmlRegexPattern
          ? `<p>${description.replace(htmlRegexPattern, '')}</p>`
          : description,
      }}
      ref={descriptionRef}
    />
  );
};

export default StrapiDescription;
